// --------------------------------------------------------------------------
// Custom questions on forms
// --------------------------------------------------------------------------
// Author:      sarah Blount
// Email:       frontend@thisiszone.com
// URL:         http://thisiszone.com
// Copyright:   Copyright (c) 2015, thisiszone.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function (options) {
    var context = options.context;
    var questionTrigger = context.find('[data-trigger-variations="true"]');
    var questionVariant = context.find('[data-variations]');
    var questionPrefill = context.find('[data-prefill]');
    var variations;
    var variantValues;

    function init() {
        // For each question which triggers label changes
        questionTrigger.each(function () {
            var triggerLabel = $(this).parents('[data-binding="custom-field"]').find('[data-binding="custom-label"]');
            var questionId = triggerLabel.data('question-id').toString();
            var triggerText = $(this).val();
            // on selecting the answer
            $(this).on('change', function () {
                // for each questions which responds to change
                questionVariant.each(function () {
                    // Split the questions data into individual options
                    variations = $(this).data('variations').split('|');
                    // Loop through each option
                    for (var i = 0; i < variations.length; i++) {
                        // Split the option into an array of 4 value
                        //  0: question Id 
                        //  1: answer text
                        //  2: replacement text 
                        //  3: replacement options
                        variantValues = variations[i].split(';');
                        // Select the correct option that matches the answer selected
                        if (questionId === variantValues[0] && triggerText === variantValues[1]) {
                            // Change the label
                            $(this).text(variantValues[2]);
                            // For checkboxes/radio buttons, change the labels
                            if (variantValues[3].length > 0) {
                                var customRadio = $(this).parent('[data-binding="custom-field"]').find('[data-binding="custom-radio"]');
                                var radioLabels = variantValues[3].split(',');
                                for (var j = 0; j < radioLabels.length; j++) {
                                    $(customRadio[j]).text(radioLabels[j]);
                                }
                            }
                        }
                    }
                });
                // prefill questions that have a data-prefill attribute on load
                questionPrefill.each(function () {
                    // Split the option into an array of 3 value
                    //  0: question Id 
                    //  1: answer text
                    //  2: replacement text 
                    var prefillValues = $(this).attr('data-prefill').split(';');
                    if (questionId === prefillValues[0] && triggerText === prefillValues[1]) {
                        $(this).val(prefillValues[2]);
                    } else {
                        $(this).val('');
                    }
                });
            });
        });
    }

    return {
        init: init
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/custom-questions.js
// module id = 230
// module chunks = 0